export type PartialBy<T, K extends keyof T> = Omit<T, K> & Partial<Pick<T, K>>;
import { FileStatusTypeConstants, FileTypeConstants, SortingValue } from '@constants';

export interface SelectOption {
  value: string;
  title: string;
  parent?: string;
  miniPhotoUrl?: string;
  miniPhotoHrmUrl?: string;
}

export interface SelectOptionsState {
  isLoading: boolean;
  items: SelectOptionsItems;
}

export interface SelectOptionsItems {
  [key: string]: FieldOption[];
}

export interface FieldOption {
  id: string;
  languageId: string;
  orderValue: number | null;
  parentId: string | null;
  translation: string;
  value: string;
  valueId: string;
}

export interface FieldOption_New {
  translation: string;
  valueId: string;
  parentId?: string;
}

export interface DictionaryValue<T = string> {
  valueId: T;
  translation: T;
  parentId?: T;
}

export interface FileIdResponse {
  createdBy?: string;
  createdDate?: Date;
  externalId: string;
  fileStatus: FileStatusTypeConstants;
  fileType: FileTypeConstants;
  id: number;
  lastModifiedBy?: string;
  lastModifiedDate?: Date;
  secured: boolean;
  filename: string;
}

export interface RequestParams {
  page: string;
  size: string;
  sort: SortingValue;
}

export interface LocalizedEntity {
  firstNameEn?: string;
  firstNameRu?: string;
  lastNameEn?: string;
  lastNameRu?: string;
}

export enum OrgUnitTypeValues {
  'UNIT' = 6,
  'DIVISION' = 4,
  'DEPARTMENT' = 1,
}

export interface OrgUnitItemResponse {
  id: number;
  orgUnitName: string;
  headId: number;
  reportsToId: number;
  orgUnitType: {
    id: number;
    orgUnitTypeNameRu: string;
    orgUnitTypeNameEn: string;
    orgUnitTypeMaxSize: number;
  };
}

export interface OrgUnitValue {
  id: number;
  orgUnitName: string;
}

export type OrgUnitFields = 'unit' | 'division' | 'department';
